import PropTypes from "prop-types";
import classNames from "classnames";
import { ButtonStyle } from "../../js/enums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Button({
  className,
  disabled,
  icon,
  iconClassName,
  isBlock = false,
  onClick,
  showSpinner = false,
  style = ButtonStyle.Info,
  text,
  title,
  type = "button",
}) {
  return (
    <button
      aria-label={title && !text ? title : undefined}
      onClick={onClick}
      title={title}
      type={type}
      className={classNames(
        "btn",
        "position-relative",
        style,
        isBlock ? "w-100" : "",
        className
      )}
      disabled={disabled}
    >
      {showSpinner && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </div>
      )}
      {icon && (
        <FontAwesomeIcon
          icon={icon}
          className={classNames(
            text ? "me-3" : "",
            showSpinner ? "opacity-25" : "",
            iconClassName
          )}
        />
      )}
      <span className={showSpinner ? "opacity-25" : ""}>{text}</span>
    </button>
  );
}

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  iconClassName: PropTypes.string,
  isBlock: PropTypes.bool,
  onClick: PropTypes.func,
  showSpinner: PropTypes.bool,
  style: PropTypes.string,
  text: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string,
};

export default Button;
